import styled from "styled-components"

const DownCaret = styled.div`
    border: solid ${(props) => props.theme.color.dimGrey};
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 2px;
    -webkit-transform: rotate(${(props) => (props.isOpen ? 45 : 225)}deg);
    transform: rotate(${(props) => (props.isOpen ? 45 : 225)}deg);

    ${(props) =>
        props.isDisabled &&
        `
        display: none;
    `}
    ${(props) => props.theme.responsive.desktop} {
        border-width: 0 2px 2px 0;
        padding: 3px;
    }
`

export default DownCaret
